import { Plugin } from '../../../types'
import { PARENTAL_LOCK_LOCAL_STORAGE_KEY } from 'components/ParentalLock/ParentalLock'

type ParentalLock = (hasParentalLock: boolean) => Plugin

export const isParentalLockActivated = (): boolean => {
  let parentalLockKey: string | null
  try {
    parentalLockKey = localStorage.getItem(PARENTAL_LOCK_LOCAL_STORAGE_KEY)

    if (parentalLockKey === null) return false
  } catch (e) {
    return false
  }

  return Boolean(parentalLockKey)
}

const parentalLock: ParentalLock = hasParentalLock => {
  const isLocked: boolean = hasParentalLock

  return (jwPlayer: jwplayer.JWPlayer | null) => {
    if (!isLocked) return

    const isParentalLockActived = isParentalLockActivated()

    if (isParentalLockActived) {
      jwPlayer?.setControls(false)
    }
  }
}

export default parentalLock
